import { gql } from '@apollo/client';

import type { GraphQLTypes } from 'src/lib/graphqlTypes';

const CURRENT_USER_FRAGMENT = gql<
  GraphQLTypes.LaunchDarklyProviderUserFragment,
  {}
>/* GraphQL */ `
  fragment LaunchDarklyProviderUserFragment on Query {
    me {
      id
      ... on User {
        email
      }
    }
  }
`;

export const LD_ME_QUERY = gql<
  GraphQLTypes.LD_ME_QUERY,
  GraphQLTypes.LD_ME_QUERYVariables
>/* GraphQL */ `
  query LD_ME_QUERY {
    ...LaunchDarklyProviderUserFragment

    me {
      id
      ... on User {
        fullName
      }
    }
  }
  ${CURRENT_USER_FRAGMENT}
`;

export const LD_ACCOUNT_QUERY = gql<
  GraphQLTypes.LD_ACCOUNT_QUERY,
  GraphQLTypes.LD_ACCOUNT_QUERYVariables
>/* GraphQL */ `
  query LD_ACCOUNT_QUERY($accountId: ID!) {
    account(id: $accountId) {
      internalID
      id
      createdAt
      currentPlan {
        id
        kind
        tier
      }
    }
  }
`;
